export default __webpack_public_path__ + "static/Effective Ways to Learn Chinese-02-b26ce68528af33cbdd23415a136bd83b.jpg";